// Copyright (c) StrangeBee 2024

import { handleNotificationError } from '@Helpers/notification';
import { NotificationController, NotificationInput, NotificationOutput } from 'thehive-sdk';

export interface NotificationEventList {
    onAdd: (notification: NotificationInput) => Promise<NotificationOutput | void>;
    onDelete: (name: string) => Promise<void>;
}

interface NotificationEventListParams {
    locale: (label: string) => string;
    controller: NotificationController;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    onError,
    onSuccess,
}: NotificationEventListParams): NotificationEventList => ({
    onAdd: (notification) =>
        controller
            .add(notification)
            .then((notification) => {
                onSuccess?.(true, 'Notification has been successfully set!');
                return notification;
            })
            .catch((e) => {
                onError?.(e);
                throw e;
            }),
    onDelete: (name) =>
        controller
            .delete(name)
            .then(() => onSuccess?.(true, 'Notification has been successfully deleted!'))
            .catch(handleNotificationError),
});
